import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { formatDateTime } from "@/lib/format";
import { Loader2, ScrollText } from "lucide-react";

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/audit-logs");
      setLogs(data);
      setLoading(false);
    })();
  }, []);

  if (loading) return <div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-brand" /></div>;

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Audit Logs</h1>
        <p className="text-muted-foreground text-sm">A record of all admin actions.</p>
      </div>
      <Card className="p-5 ip-card-shadow">
        {logs.length === 0 ? (
          <p className="text-center text-muted-foreground py-8">No audit entries yet.</p>
        ) : (
          <div className="divide-y divide-border/60">
            {logs.map((l) => (
              <div key={l.id} className="flex items-start gap-3 py-3" data-testid={`audit-${l.id}`}>
                <div className="h-8 w-8 grid place-items-center rounded-lg bg-brand-light text-brand shrink-0"><ScrollText className="h-4 w-4" /></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm"><b className="capitalize">{l.action.replace(/_/g, " ")}</b> <span className="text-muted-foreground">on {l.target_type}</span></p>
                  {l.details && <p className="text-xs text-muted-foreground truncate">{l.details}</p>}
                  <p className="text-xs text-muted-foreground mt-0.5">{l.admin_email} · {formatDateTime(l.at)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
